module.exports = __webpack_public_path__ + "img/admin-account.a0115b7a.svg";